// extracted by mini-css-extract-plugin
export default {"fieldset":"NewFrazerPayPaymentMethodForm_fieldset__+8d+e","checkbox":"NewFrazerPayPaymentMethodForm_checkbox__eMcA+","cvvDetails":"NewFrazerPayPaymentMethodForm_cvvDetails__ukGcr"};